import { IncomeVerificationDocument } from '../types/incomeVerificationType';
import { apiPost } from './axios';

export const postIncomeVerificationDocument = async (formData: IncomeVerificationDocument) => {
  const res = await apiPost('/id-process', formData);
  return res.data;
};
